import React, { useRef, useMemo } from 'react'
import FixedTooltip from '~/app/components/common/Tooltip/FixedTooltip'
import { styled } from '~/app/components'
import { Icon_info } from '@yanolja-rnd/ya-com-system-icon'
import { Typography } from '@yanolja-rnd/ya-com-core'

const ExceptionalCancelPolicyWrapper = styled.div`
  margin-top: 1.2rem;
  color: ${({ theme }) => theme.color.yared};
  ${Typography('body2').regular};
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
  &:hover {
    @media (hover: hover) and (pointer: fine) {
      cursor: pointer;
    }
  }

  span {
    margin-right: 0.2rem;
  }
`

const ExceptionalCancelPolicyTooltip = styled.div`
  ${Typography('body2').regular};
`
const InfoIcon = styled(Icon_info)`
  path {
    fill: ${({ theme }) => theme.color.yared};
  }
`

type ExceptionalCancelPolicyTextProps = {
  isExceptionalCancelPolicy: boolean
  isCancelFree: boolean
}

const ExceptionalCancelPolicyText: React.FC<ExceptionalCancelPolicyTextProps> = ({
  isExceptionalCancelPolicy,
  isCancelFree,
}) => {
  const exceptionalCancelPolicyTooltipContent = useRef(
    <ExceptionalCancelPolicyTooltip>
      본 상품은 <b>NOL 정책이 아닌 호텔 자체의 취소, 환불 정책</b>이 적용되므로,{' '}
      <b>예약 완료 후 10분 이내 무료 취소가 불가능 한 상품</b>임을 반드시 주의하여 주시기 바랍니다
    </ExceptionalCancelPolicyTooltip>
  ).current

  const isShow = useMemo(() => {
    // 무료 취소 가능 시점에는 노출하지 않음.
    return isCancelFree ? false : isExceptionalCancelPolicy
  }, [isCancelFree, isExceptionalCancelPolicy])

  if (!isShow) {
    return null
  }

  return (
    <FixedTooltip
      content={exceptionalCancelPolicyTooltipContent}
      includeCloseIcon={true}
      stickyTo={'right'}
      customTooltipRight={0.1}
      placement={'bottom'}
      width={28.5}
      borderRadius={0.4}
      tooltipOffset={40}
    >
      <ExceptionalCancelPolicyWrapper>
        <span>{'예약 완료 후 무료취소 제외 상품'}</span>
        <InfoIcon size={1.4} unit="rem" />
      </ExceptionalCancelPolicyWrapper>
    </FixedTooltip>
  )
}

export default ExceptionalCancelPolicyText
